export default {
  orders: [],
  order: {},
  statistics: {},
  trackingInfo: [],
  orderItemHistory: [],
};
